import { getSrcWithParams } from './getSrcWithParams';
export const getSrcSetFromWidths = (src, widths, aspect, options = { crop: false }) => widths
    .map(w => {
    return getSrcWithParams(w, aspect, src, true, options);
})
    .join(', ');
//# sourceMappingURL=getSrcSetFromWidths.js.map